<template>
	<div>
		<upload-header
			:title="headerTitle"
			:subtitle="currentCrop.name"
		/>

		<upload-crop
			:item="currentCrop"
			:ratio="cropRatio"
			:minimum-width="minimumWidth"
			:minimum-height="minimumHeight"
			@changed="specifications = $event"
		/>

		<upload-footer>
			<helio-button
				:text="$t('upload.image-crop.cancel')"
				@click.stop="$emit('cancel-crop')"
			/>

			<helio-button
				:text="$t('upload.image-crop.apply')"
				:state="croppingStatus"
				color="primary"
				:status-timer="500"
				@click.stop="processCrop"
			/>
		</upload-footer>
	</div>
</template>

<script>
import Button from '../../../button/Button.vue';
import Footer from '../../footer/Footer.vue';
import Header from '../../header/Header.vue';
import Crop from '../../crop/Crop.vue';
import Centios from '../../../../utils/communication/Centios';

export default {
	components: {
		'helio-button': Button,
		'upload-footer': Footer,
		'upload-header': Header,
		'upload-crop': Crop,
	},

	props: {
		cropRatio: {
			type: String,
			required: false,
			default: null,
		},

		api: {
			type: String,
			required: true,
		},

		items: {
			type: Array,
			required: false,
			default: () => [],
		},

		minimumWidth: {
			type: Number,
			required: true,
		},

		minimumHeight: {
			type: Number,
			required: true,
		},
	},

	data() {
		return {
			specifications: [],
			croppingStatus: null,
			numberOfImagesToCrop: 0,
		};
	},

	computed: {
		currentCrop() {
			if (this.items.length > 0) {
				return this.items[0];
			}

			return null;
		},

		headerTitle() {
			if (this.numberOfImagesToCrop > 1) {
				return this.$t('upload.image-crop.title.multiple', [this.numberOfImagesToCrop - this.items.length + 1, this.numberOfImagesToCrop]);
			}

			return this.$t('upload.image-crop.title.single');
		},
	},

	mounted() {
		this.numberOfImagesToCrop = this.items.length;
	},

	methods: {
		processCrop() {
			let x = 0;
			let y = 0;
			const width = Math.round((this.currentCrop.width * this.specifications.width) / 100);
			const height = Math.round((this.currentCrop.height * this.specifications.height) / 100);

			if (this.specifications.position.left !== undefined) {
				x = (this.specifications.position.left * this.currentCrop.width) / 100;
			} else if (this.specifications.position.right !== undefined) {
				const positionFromLeft = 100 - this.specifications.position.right;
				x = ((positionFromLeft * this.currentCrop.width) / 100) - width;
			}
			x = Math.round(x);

			if (this.specifications.position.top !== undefined) {
				y = (this.specifications.position.top * this.currentCrop.height) / 100;
			} else if (this.specifications.position.bottom !== undefined) {
				const positionFromTop = 100 - this.specifications.position.bottom;
				y = ((positionFromTop * this.currentCrop.height) / 100) - height;
			}
			y = Math.round(y);

			if (this.currentCrop.type === 'file') {
				const endpoint = `${this.api}/medias/crop`;
				const formData = {
					x,
					y,
					width,
					height,
					url: this.currentCrop.url,
				};

				this.croppingStatus = 'is-loading';

				Centios.submit('post', endpoint, formData).then((response) => {
					if (Centios.isValid(response.data)) {
						this.croppingStatus = 'is-successful';
						this.$emit('crop', this.currentCrop);
					}
				});
			} else if (this.currentCrop.type === 'unsplash') {
				const modifiedUrl = `${this.currentCrop.full}&rect=${x},${y},${width},${height}`;
				this.currentCrop.full = modifiedUrl;
				this.currentCrop.thumbnail = `${modifiedUrl}&fit=crop&max-w=300&max-h=200`;
				this.$emit('crop', this.currentCrop);
			}
		},
	},
};
</script>
